module.exports = __webpack_public_path__ + "static/img/fire-fox.c3adea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fire-fox.png
// module id = tHie
// module chunks = 0